
define('text!templates/modules/calendar/calendar/summary/summary-tables/summary-header.html',[],function () { return '<tr>\n    {{#headers}}\n    <th>{{#t}}{{.}}{{/t}}</th>\n    {{/headers}}\n</tr>\n';});

